//is this the correct way of checking input fields?
// export const SERVICE_DESCRIPTIONS = {
//     'postnl': [
//         { type: 'input', field: 'pass', label: 'API Key' },
//         //{ type: 'step', title: 'text'},
//     ],
//     'dpd': [ //example for carriers that requires pass and user
//         { type: 'input', field: 'user', label: 'Client ID' },
//         { type: 'input', field: 'pass', label: 'API Key' }
//     ]
// }

import { ServiceGroup } from '@/models/interfaces/service'

export const SERVICE_DESCRIPTIONS = {
    'basicauth': [
        { type: 'input', field: 'pass', label: 'API Key' },
    ],
    'apikey': [
        { type: 'input', field: 'user', label: 'Username' },
        { type: 'input', field: 'pass', label: 'Password' }
    ]
}

export function createConfig (serviceType, pass?, user?, client_id?, client_secret?) {
    switch (serviceType) {
        case 'apikey':
            return {
            group: ServiceGroup.Shipment,
            apiKey: pass,
            test: false,
            verbose: false
            }
        case 'basicauth':
            return {
            group: ServiceGroup.Shipment,
            test: false,
            basicAuth: {
                user,
                pass
            },
        }
        case 'oauth':
            return {
            group: ServiceGroup.Shipment,
            test: false,
            oauth: {
                client_id,
                client_secret,
                user,
                pass
            },
        }
    default:
        throw Error(`Cannot create service config, unknown service ${serviceType}`)
    }
}
